import { CurrencyPipe, DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MsalModule, MsalService, MsalGuard, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionType } from '@azure/msal-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { loginRequest } from './config/msal.config';
import { msalInstance } from './config/msal.instance';
import { AuthInterceptor } from './authinterceptor';
import { Initialize } from './init';
import { LoginPage } from './pages/login/login.page';
import { NewsDetailsPage } from './pages/news/news-details/news-details.page';
import { CnpjPipe } from './pipes/cnpjPipe/cnpj.pipe';
import { I18nPipe } from './pipes/i18n/i18n.pipe';
import { PhonePipe } from './pipes/phonePipe/phone.pipe';
import { PipesModule } from './pipes/pipes.module';
import { SharedModule } from './shared/shared.module';
import { environment } from '../environments/environment';

export function translateLoaderFactory(http: HttpClient) {
  registerLocaleData(localePt);
  registerLocaleData(localeEs);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    MsalModule.forRoot(
      msalInstance,
      {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest,
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map(),
      },
    ),
    AppRoutingModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.id !== 'DEV',
      // Register the ServiceWorker as soon as the application is stable
      // or after 10 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:10000',
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    PipesModule,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    Initialize,
    I18nPipe,
    LoginPage,
    NewsDetailsPage,
    DatePipe,
    CurrencyPipe,
    CnpjPipe,
    DecimalPipe,
    PhonePipe,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
